export default "/images/643fdfbaa1673c9c9631983ab4368078.png";